<template>
  <label :for="sid" class="radio" v-bind:class="{ 'state-disabled': disabled, 'state-error': model.$error }">
    <input type="radio" :checked="checked" :disabled="disabled" :id="sid" ref="input" :value="value" @change="onInput($event)" @focus="onFocus($event)" @blur="onBlur($event)" />
    <i></i>
    <slot>{{ getTitle }}</slot>
    <w-error :model="model"></w-error>
  </label>
</template>

<script>
import modelMixin from '../../mixins/modelMixin';
import WError from './error.vue';

export default {
  // props: ['model', 'value'],
  components: {
    WError
  },
  mixins: [modelMixin],
  data() {
    return {
      sid: 'rad.' + this.value + '.' + Math.random() * 1000000
    };
  },
  computed: {
    checked() {
      // if (this.$options.hasFocus) {
      //   return this.model.$model === this.value;
      // }
      return this.model.$model === this.value;
    }
  },
  // mounted() {},
  methods: {
    onFocus(evt) {
      this.$options.hasFocus = true;
      this.$emit('focus');
    },
    onBlur(evt) {
      this.$options.hasFocus = false;
      this.$emit('blur');
    },
    onInput(evt) {
      this.$options.localValue = evt.target.checked;
      if (evt.target.checked) {
        this.model.$model = this.value;
      }
      this.$emit('input');
      this.fieldChanged();
    }
  }
};
</script>
